import React, { useLayoutEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';

import getAllUrlParams from '../../shared/utils/getAllUrlParams';
import { submitRefreshToken } from '../../modules/login/ducks/loginActions';
import Logger from 'js-logger';

const LoginRoute = ({
  component: Component,
  authed,
  path,
  ...rest
}) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  return (
    <Route
      {...rest}
      render={
        (props) => (
          authed === false
            ? <Component {...props} />
            // ? (
            //   <Route
            //     path={path}
            //     component={() => {
            //       window.location = 'https://app.teambuildr.com/login';
            //     }}
            //   />
            : (
              <Route
                path={path}
                component={() => {
                  // window.location.href = `https://${process.env.ENVIRONMENT === 'STAGING' ? 'staging.' : ''}app.teambuildr.com/login?rel=${path.replace('/', '')}&version=2`;
                  // // window.location.href = `http://localhost:8080/login`;
                  // if (process.env.ENVIRONMENT === 'LOCAL') {
                  //   window.location.href = 'http://localhost:8080/login';
                  // }
                  const url = getAllUrlParams(window.location.href, false);
                  let domain;
                  if (process.env.PHP_APP_URL && process.env.WEBAPP_URL) {
                    // Athletes always go to webapp; admins go to webapp if version=2 or targeting dashboard
                    domain = (url.version === '2' || currentUser.admin === 0 || !url.rel || url.rel === 'dashboard')
                      ? process.env.WEBAPP_URL
                      : process.env.PHP_APP_URL;
                  } else {
                    const isDevelop = process.env.ENVIRONMENT === 'DEVELOP' ? 'dev.' : '';
                    const isV2 = url.version === '2' || currentUser.admin === 0 || !url.rel || url.rel === 'dashboard';
                    const subdomain = isV2 ? 'app-v3' : 'app';
                    domain = `https://${process.env.ENVIRONMENT === 'STAGING' ? 'staging.' : isDevelop}${subdomain}.teambuildr.com`;
                  }
                  const isAthlete = currentUser.admin === 0;
                  const targetPath = url.rel === undefined ? (isAthlete ? 'workouts' : 'dashboard') : url.rel;

                  // Preserve other query parameters (excluding rel and version)
                  // getAllUrlParams lowercases param names
                  const preservedParams = new URLSearchParams();
                  Object.keys(url).forEach((key) => {
                    if (key !== 'rel' && key !== 'version') {
                      preservedParams.set(key, url[key]);
                    }
                  });
                  const queryString = preservedParams.toString();

                  window.location = `${domain}/${targetPath}${queryString ? `?${queryString}` : ''}`;
                  return null;
                }}
              />
              // <Redirect to={`/login?rel=${path.replace('/', '')}&version=2`} />
            )
        )
      }
    />
  );
};

export default LoginRoute;
